export default __webpack_public_path__ + "static/media/d-2.5853be32.jpg";